var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Icon, Text } from 'shared/components';
import { Emergency, Info } from 'shared/assets/icons';
import { useWatch } from 'react-hook-form';
import { UndoFormReason } from '../types';
export var ReasonWarning = function () {
    var reason = useWatch({ name: 'reason' });
    if (!reason) {
        return _jsx(_Fragment, {});
    }
    else if (reason === UndoFormReason.arrivedLate) {
        return (_jsx(Box, __assign({ backgroundColor: "blue.100", color: "blue.500", padding: 4, mb: 3, rounded: "2xl", mt: 2 }, { children: _jsxs(Flex, __assign({ flexDir: "row" }, { children: [_jsx(Icon, { as: Info, mr: 3, boxSize: 4 }), _jsx(Flex, __assign({ flexDir: "row" }, { children: _jsx(Text, __assign({ size: "body2" }, { children: "This note will change from signed to draft" })) }))] })) })));
    }
    else {
        return (_jsx(Box, __assign({ backgroundColor: "red.100", color: "red.500", padding: 4, mb: 3, rounded: "2xl", mt: 2 }, { children: _jsxs(Flex, __assign({ flexDir: "row" }, { children: [_jsx(Icon, { as: Emergency, mr: 3, boxSize: 4 }), _jsx(Flex, __assign({ flexDir: "row" }, { children: _jsx(Text, __assign({ "data-testid": "warningMessage", size: "body2" }, { children: "This note will be deleted from this client's chart. Before deleting this note, be sure to copy / paste any content you need to the correct note." })) }))] })) })));
    }
};
